export default __webpack_public_path__ + "static/media/nginx.2503c407.svg";